import { EntidadeBase } from 'hay-core-react';
class MidiaModel extends EntidadeBase {
    constructor() { super('midia'); }
}

const instance = new MidiaModel();
export default instance;
